import { Component } from "@angular/core";
import { PROMOTION_SELECTOR } from "../../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../../base/base.component";
import { AppComponent } from "../../../app.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../../crossconcern/utilities/utils/alert.utils";

@Component({
    selector: PROMOTION_SELECTOR,
    templateUrl: "./promotion.component.html"
})
export class PromotionComponent extends BaseComponent {
    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }
}